<template>
  <div>
    <vs-row v-if="page.type === 'setting'">
      <!-- menu left -->
      <vs-col vs-w="9">
        <vs-row>
          <vs-col vs-w="12" style="background: #eee" class="p-5">
            <b-row
              v-for="(item, index) in page.role[active2 - 2].access"
              :key="index"
            >
              <vs-col vs-w="12" class="p-5">
                <vs-checkbox color="success" v-model="item.value">
                  {{ item.name }}</vs-checkbox
                >
              </vs-col>
              <vs-col
                vs-offset="1"
                v-tooltip="'col-2'"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="center"
                vs-w="12"
              >
                <vs-col v-for="(sub, index2) in item.actions" :key="index2">
                  <vs-checkbox color="success" v-model="sub.value"
                    >{{ sub.name }}
                  </vs-checkbox>
                </vs-col>
              </vs-col>
            </b-row>
          </vs-col>
        </vs-row>
      </vs-col>
  

      <!-- menu right-->

      <div>
        <b-sidebar
          id="sidebar-border"
          sidebar-class="border-right border-danger"
          right
          shadow
          width="260px"
          no-header-close="true"
          v-model="active"
        >
          <div class="mt-24">
            <div class="flex justify-center">
              <h4>Setting</h4>
            </div>
            <div class="mx-3 my-2">
              <div class="sidebar-item" @click="popupActivo = true">
                <vs-icon icon="add" class="mr-5"></vs-icon>Add New Role
              </div>
              <div v-for="(item, index) in page.role" :key="index">
                <div class="sidebar-item">
                  <vs-icon
                    icon="delete"
                    class="mr-5"
                    @click="del(index)"
                  ></vs-icon
                  ><span @click="chooseItem(index)" v-if="item.isActive" class="Active">{{ item.name }}</span>
                  <span @click="chooseItem(index)" v-else>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-sidebar>
      </div>

      <vs-popup
        class="holamundo"
        title="ADD NEW ROLE"
        :active.sync="popupActivo"
      >
      <vs-row class="flex justify-center">
      <vs-input class="inputx" placeholder="NEW ROLE" v-model="role"/>
      <vs-button color="success" type="filled" @click="postRole">Done</vs-button>
      </vs-row>
      </vs-popup>

      <!-- <vs-sidebar
        position-right
        parent="body"
        color="primary"
        hidden-background
        spacer
        v-model="active"
        :default-index="active2"
      >
        <div class="mt-24">
          <div class="header-sidebar flex justify-center" slot="header">
            <h4>Setting</h4>
          </div>

          <vs-sidebar-item index="1" icon="add" class="mt-3">
            Add New Role
          </vs-sidebar-item>

          <vs-sidebar-item
            v-for="(item, index) in page.role"
            :key="index"
            :index="index + 2"
            icon="delete"
            @click="s(index)"
          >
            {{ item.name }}
          </vs-sidebar-item>
        </div>
      </vs-sidebar> -->
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ page: "general/page", sidebar:"general/sidebar" }),
  },
  data() {
    return {
      active: false,
      active2: 2,
      popupActivo: false,
      role: "",
      isActive:false,
    };
  },
  // beforeCreate() {
  //    if (this.page.role) {
  //     // console.log("third", this.page.role);
  //     for (const [i, el] of this.page.role.entries()) {
  //       // console.log("i", i);
  //       // console.log("el", el);
  //       if (i === 0) {
  //         el.isActive = true;
  //       } else {
  //         el.isActive = false;
  //       }
  //     }
  //   }
  // },

  methods: {
    chooseItem(index) {
      // this.isActive = !this.isActive;
      // this.page.role[index].isActive = !this.page.role[index].isActive;
      this.page.role.forEach((a,i)=>{
        console.log(a);
        if(index === i){
          a[index].isActive = true;
        }
        else{
          a[index].isActive = false;
        }
      })
    },
    postRole(e){
      e.preventDefault();
      this.popupActivo = false;
    },

  },
  mounted() {
    this.active = true;
  },
  watch: {
    page(oldvalue,newvalue){
      console.log(oldvalue,newvalue);
    }
  }
};
</script>

<style lang="scss">
.adminActive {
  background: #939393 !important;
}

.sidebar-item:hover {
  text-decoration: underline;
}

.Active{
   color: blue;
}

</style>
